import { Injectable, OnInit } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PharmacyService implements OnInit {
  apiUrl = environment.apiUrl
  pharmacyData: any = JSON.parse(localStorage.getItem('logindata'))
  headers: HttpHeaders
  constructor(private http: HttpClient) {


  }

  ngOnInit() {

    this.headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + this.pharmacyData != null ? this.pharmacyData['accessToken'] : '',
      'accept': 'application/json',

    });
  }

  getPharmacyList(skip, object) {
    let lat = localStorage.getItem('lat')
    let lng = localStorage.getItem('lng')
    let params = {}
    if (lat == 'undefined') { }
    else {
      params["lat"] = lat
    }
    if (lng == 'undefined') { }
    else {
      params["lng"] = lng
    }
    params["skip"] = skip

    if (object.value && object.value.name)
      params["name"] = object.value.name
    if (object.value && object.value.city)
      params["city"] = object.value.city.toLowerCase()

    if (object.type) {
      params["type"] = object.type;
    }
    if (object.timeZone) {
      params["timeZone"] = object.timeZone;
    }
    const httpOptions = {

      params: params

    };

    return this.http.get(`${this.apiUrl}/User/listPharmecies`, httpOptions)
  }
  getpharmacyDetail(pharmacyId: string, latest_date) {
    let params = {}
    params['_id'] = pharmacyId
    params['selectDate'] = latest_date
    const httpOptions = {

      params: params
    };
    return this.http.get(`${this.apiUrl}/User/listPharmecyDetails`, httpOptions)
  }
  getAllBookings(date = null, phoneNo = '') {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    if (date && phoneNo)
      return this.http.get(`${this.apiUrl}/Pharmecy/listBookings?date=${date}&phoneNo=${phoneNo}`, { headers: headers1 })

    else if (phoneNo)
      return this.http.get(`${this.apiUrl}/Pharmecy/listBookings?phoneNo=${phoneNo}`, { headers: headers1 })
    else if (date)
      return this.http.get(`${this.apiUrl}/Pharmecy/listBookings?date=${date}`, { headers: headers1 })
    else
      return this.http.get(`${this.apiUrl}/Pharmecy/listBookings`, { headers: headers1 })


    // return this.http.get(`${this.apiUrl}/Pharmecy/listBookings`,{headers:headers1,params:params})
  }
  fileUpload(file) {
    let formData = new FormData();
    formData.append("file", file);
    let token = localStorage.getItem('token')

    let fileHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + token,
      //   'Content-Type': 'multipart/form-data',
      'accept': 'application/json'
    })


    return this.http.post(`${this.apiUrl}/Upload/images`, formData, { headers: fileHeaders })
  }
  pharmacyBooking(pharmecyId: string, pharmecyBookingData, addressField) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let data = {
      pharmecyId: pharmecyId,
      images: pharmecyBookingData,
      ...addressField
    }

    return this.http.post(`${this.apiUrl}/User/pharmecyBooking`, data, { headers: headers1 })

  }
  pharmacyBookingByPharmacy(pharmecyBookingData, addressField, countryCode, phoneNo) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let data = {

      countryCode: countryCode,
      phoneNo: phoneNo,
      images: pharmecyBookingData,
      ...addressField
    }

    return this.http.post(`${this.apiUrl}/Pharmecy/createOrder`, data, { headers: headers1 })

  }
  updateBookingStatus(status: string, bookingID: string) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Pharmecy/bookingStatusUpdate`, { _id: bookingID, status: status }, { headers: headers1 })
  }
  setPasword(password) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Pharmecy/setPassword`, { password: password }, { headers: headers1 })
  }
  getReviews() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });


    return this.http.get(`${this.apiUrl}/Pharmecy/listReview`, { headers: headers1 })


  }
  pharmecyDistance(addressFields, pharmecyId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/User/pharmecyDistance?pharmecyId=${pharmecyId}&lat=${addressFields.lat}&lng=${addressFields.lng}`, { headers: headers1 })
  }
  getTimingStatus(pharmecyId, addressFields) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/User/pharmecyTimingStatus?pharmecyId=${pharmecyId}&time=${addressFields.dateTime}`, { headers: headers1 })
  }
}
